import React from 'react';
import { styled } from '@linaria/react';

import FormatIcon, {
  type Status,
} from '@/components/AnimatedIcons/FormatIcon';

import ActionButton from './ActionButton';

function FormatButton({
  accentColor = 'var(--color-primary)',
  handleFormat,
}: {
  accentColor: string;
  handleFormat: () => void;
}) {
  const [status, setStatus] = React.useState<Status>('idle');

  React.useEffect(() => {
    if (status !== 'formatting') {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setStatus('idle');
    }, 200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [status]);

  return (
    <Wrapper
      onClick={handleFormat}
      onMouseEnter={() => setStatus('hovering')}
      onMouseLeave={() => {
        if (status !== 'formatting') {
          setStatus('idle');
        }
      }}
      onMouseDown={() => setStatus('pressed')}
      onMouseUp={() => setStatus('formatting')}
    >
      <FormatIcon
        size={16}
        status={status}
        accentColor={accentColor}
      />
    </Wrapper>
  );
}

const Wrapper = styled(ActionButton)`
  transform-origin: center center;
`;

export default FormatButton;
